export default __webpack_public_path__ + "static/media/views_back.f47a8437.svg";